export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      token: '',
      validUntil: null,
      units: [],
      groups: []
    }
  },
  apiTokenSources () {
    return [
      { text: 'Units', value: 'units' },
      { text: 'Groups', value: 'groups' }
    ]
  }
}